import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function AwardsHome() {
  return (
    <section className="tekrevol__awardshome overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div
              className="example example-bottom text-center"
              data-text="Awards"
            >
              <h2>Awards & Recognition</h2>
              <p>
                We thrive on accelerating the path to disruption and
                implementing agile methodologies to design, build, deliver, and
                scale digital solutions. Our future-proof, growth-centric tech
                has earned us notable awards and recognition across industries
                and regions.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          ></Col>
        </Row>
        <div className="awards-wrap">
          <Row className="justify-content-center">
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/inc-5000.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>INC. 5000</h5>
                  <p>America's Fastest Growing Companies</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/dot-com.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Dot Comm</h5>
                  <p>Excellence in Web Creativity & Digital Communication</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/Clutch.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Clutch</h5>
                  <p>Top 1000 Companies</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/top_developer.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Top Developers</h5>
                  <p>Top Entertainment App Developers</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/expertise-logo.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Expertise</h5>
                  <p>Best Mobile App Developer</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/top_Reated.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Software World</h5>
                  <p>Top App Development Companies</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/Horizon.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Horizon Award</h5>
                  <p>Gold Awards Winner 2020</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/rank-watch.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Rank Watch</h5>
                  <p>Top Web Development Agencies 2023</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/Horizon_Sliver.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Horizon Award</h5>
                  <p>Silver Awards Winner 2020</p>
                </div>
              </div>
            </Col>
            <Col xs={6} md={3} lg={3} xl={2} xxl={2} className="">
              <div className="awards-inner text-center">
                <div className="image">
                  <StaticImage
                    src="../../images/awards/right-firms.webp"
                    alt="TekRevol"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={180}
                    height={130}
                  />
                </div>
                <div className="content">
                  <h5>Right firms</h5>
                  <p>Top Mobile App Development Company 2023</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default AwardsHome;
